// FETCH ORDERS TYPES

export enum OrdersActionTypes {
  FETCH_ORDERS_SAGA = "FETCH_ORDERS_SAGA",
  FETCH_ORDERS_SUCCESS = "FETCH_ORDERS_SUCCESS",
  FETCH_ORDERS_ERROR = "FETCH_ORDERS_ERROR",
  FETCH_ORDER_ERROR_MESSAGE_SAGA = "FETCH_ORDER_ERROR_MESSAGE_SAGA",
  FETCH_ORDER_ERROR_MESSAGE_SUCCESS = "FETCH_ORDER_ERROR_MESSAGE_SUCCESS",
  CLEAR_ORDER_ERROR_MESSAGE = "CLEAR_ORDER_ERROR_MESSAGE",
}
